import config from '../assets/json/config.json';

const { auth0domain, auth0clientId, auth0audience } = config as any;

export const environment = {
  production: false,
  configPath: 'assets/json/config.json',
  auth: {
    domain: auth0domain,
    clientId: auth0clientId,
    authorizationParams: {
      ...(auth0audience && auth0audience !== 'YOUR_API_IDENTIFIER'
        ? { audience: auth0audience }
        : null),
      redirect_uri: window.location.origin,
    },
    errorPath: '/error',
  },
  httpInterceptor: {
    allowedList: [`http://localhost:3001/*`],
  },
  appUri: 'http://localhost:4200',
};
